'use strict';

import urlFormat from './url-format';
import limitTo from './limit-to';
import attrAdd from './attr-add';
import dateFormat from './date-format';
import companyRole from './company-role';
import userMember from './user-member';
import socialType from './social-type';

export default {
  socialType,
  userMember,
  companyRole,
  urlFormat,
  limitTo,
  attrAdd,
  dateFormat
};



// WEBPACK FOOTER //
// ./src/common/filters/index.js